/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_GitignoreInputs */

const en_rd_check_gitignore = /** @type {(inputs: Rd_Check_GitignoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.gitignore covers deps, env and build output`)
};

const id_rd_check_gitignore = /** @type {(inputs: Rd_Check_GitignoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.gitignore mencakup dependensi, env, dan hasil build`)
};

/**
* | output |
* | --- |
* | ".gitignore covers deps, env and build output" |
*
* @param {Rd_Check_GitignoreInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_gitignore = /** @type {((inputs?: Rd_Check_GitignoreInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_GitignoreInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_gitignore(inputs)
	return en_rd_check_gitignore(inputs)
});